// Dummy authentication data
// In production, this would be stored securely and fetched from a backend

export const dummyUsers = {
  admin: {
    role: 'admin',
    pin: '774481', // 6-digit PIN for admin
    name: 'Admin User',
  },
  waiter: [
    // Demo waiters for login
    {
      userId: 'captain1',
      password: '11',
      role: 'waiter',
      name: 'Captain 1',
    },
    {
      userId: 'captain2',
      password: '22',
      role: 'waiter',
      name: 'Captain 2',
    },
    {
      userId: 'captain3',
      password: '33',
      role: 'waiter',
      name: 'Captain 3',
    },
    {
      userId: 'captain4',
      password: '44',
      role: 'waiter',
      name: 'Captain 4',
    },
  ],
  counter: [
    {
      userId: 'counter',
      password: 'counter',
      role: 'counter',
      name: 'Counter',
    },
  ],
  kitchen: [
    {
      userId: 'kitchen',
      password: '',
      role: 'kitchen',
      name: 'Kitchen',
    },
  ],
};

// Authentication helper functions
export const authenticateAdmin = (pin) => {
  return pin === dummyUsers.admin.pin;
};

export const authenticateUser = (role, userId, password) => {
  const users = dummyUsers[role];
  if (!users || !Array.isArray(users)) return null;
  
  const user = users.find(
    (u) => u.userId === userId && (u.password === password || u.password === '')
  );
  
  return user || null;
};

// Get user info after authentication
export const getUserInfo = (role, credentials) => {
  if (role === 'admin') {
    return dummyUsers.admin;
  }
  
  const user = authenticateUser(role, credentials.userId, credentials.password);
  return user;
};

